module.exports = __webpack_public_path__ + "img/1.b6ec4593.png";